// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-field-edit-languages .settings-section-label-container {
  margin-bottom: 20px;
}
.data-field-edit-languages .settings-section-label-container .settings-section-label {
  font-size: 18px;
  margin-bottom: 0;
}
.data-field-edit-languages .settings-section-label-container .settings-section-label-description {
  font-size: 14px;
  color: var(--fi-color-grey);
}
.data-field-edit-languages .mat-mdc-radio-group .mat-mdc-radio-button {
  margin-bottom: 20px;
}
.data-field-edit-languages .mat-mdc-radio-group .mat-mdc-radio-button .mdc-form-field label {
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./Source/app/data-field/data-field-edit/languages/languages.component.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AACQ;EACI,eAAA;EACA,gBAAA;AACZ;AACQ;EACI,eAAA;EACA,2BAAA;AACZ;AAGQ;EACI,mBAAA;AADZ;AAEY;EACI,eAAA;AAAhB","sourcesContent":[".data-field-edit-languages {\r\n    .settings-section-label-container {\r\n        margin-bottom: 20px;\r\n        .settings-section-label {\r\n            font-size: 18px;\r\n            margin-bottom: 0;\r\n        }\r\n        .settings-section-label-description {\r\n            font-size: 14px;\r\n            color: var(--fi-color-grey);\r\n        }\r\n    }\r\n    .mat-mdc-radio-group {\r\n        .mat-mdc-radio-button {\r\n            margin-bottom: 20px;\r\n            .mdc-form-field label {\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
